import {
    getBasePrice,
    getFinalPrice,
    getMaximumPrice,
    getMinimalPrice,
} from '@/_application/modules/products/model/price';
import usePrice from '@/lib/use-price';
import {ProductInterface} from '__generated__/__types__';

export function useCalculatePrices(selectedProduct: ProductInterface, flashSaleDealPrice?: number | null) {
    const finalPrice = getFinalPrice(selectedProduct);
    const productBasePrice = getBasePrice(selectedProduct);
    const minimumPrice = getMinimalPrice(selectedProduct);
    const maximumPrice = getMaximumPrice(selectedProduct);

    const hasFlashSaleDealPrice = flashSaleDealPrice != null && flashSaleDealPrice > 0;
    const effectiveAmount = hasFlashSaleDealPrice ? flashSaleDealPrice : (finalPrice?.value ?? 0);

    const {price, basePrice, discount} = usePrice({
        amount: effectiveAmount,
        baseAmount: productBasePrice.value ?? 0,
        currencyCode: hasFlashSaleDealPrice ? (productBasePrice.currency ?? 'VND') : (finalPrice?.currency ?? 'VND'),
    });
    const {price: minPrice} = usePrice({
        amount: minimumPrice.value!,
        currencyCode: minimumPrice.currency ?? 'VND',
    });
    const {price: maxPrice} = usePrice({
        amount: getMaximumPrice(selectedProduct).value!,
        currencyCode: maximumPrice.currency ?? 'VND',
    });

    return {
        maximumPrice,
        minimumPrice,
        minPrice,
        maxPrice,
        discount,
        basePrice,
        price,
    };
}

